<template>
    <div class="animated fadeIn page-new">
        <b-row v-if="true">
            <b-form @submit.prevent="save" action="111" class="col-md-12" >
                <b-row>
                    <b-col sm="12" class="main-page">
                        <b-card footer-tag="footer">
                            <div slot="header">
                                <strong v-if="data.name">{{ data.name }}</strong>
                            </div>
                            <b-row  v-bind:class="{'ptt-loading':loading}">
                                <b-col cols="6" xl="6" lg="12">
                                    <h6 class="mb-3">Thông tin chi tiết</h6>
                                    <b-form-group
                                            label="Tên thành viên <span style='color:red'>*</span>"
                                            label-for="input-name"
                                            :label-cols="2"
                                            :horizontal="true">
                                      <template slot="label">
                                        Tên thành viên <span style="color:red">*</span>
                                      </template>
                                        <b-form-input id="input-name" type="text" placeholder="Nhập tên thành viên"  v-model="data.name"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Địa chỉ email <span style='color:red'>*</span>"
                                            label-for="input-email"
                                            :label-cols="2"
                                            :horizontal="true">
                                      <template slot="label">
                                        Địa chỉ email <span style='color:red'>*</span>
                                      </template>
                                        <b-form-input id="input-email" type="email" placeholder="Nhập email thành viên"  v-model="data.email"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Địa chỉ"
                                            label-for="input-address"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-address" type="text" placeholder="Nhập địa chỉ"  v-model="data.address"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Số điện thoại"
                                            label-for="input-phone"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-phone" type="text" placeholder="Nhập số điện thoại"  v-model="data.phone"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Ngày sinh"
                                            label-for="input-birthday"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-birthday" type="date" placeholder="Nhập ngày sinh"  v-model="data.birthday"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                            label="Số thiết bị"
                                            label-for="input-device-limit"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-device-limit" type="number" placeholder="Nhập số thiết bị được truy cập"  v-model="data.device_limit"></b-form-input>
                                    </b-form-group>

                                    <b-row>
                                        <b-col cols="12" xl="8" lg="8">
                                            <b-form-group
                                                    label="Trạng thái"
                                                    label-for="input-status"
                                                    :label-cols="4"
                                                    :horizontal="true">
                                                <b-form-select id="input-status" v-model="data.status">
                                                    <option :value="1">Đang hoạt động</option>
                                                    <option :value="2">Ngừng hoạt động</option>
                                                    <option :value="3">Tạm Khóa</option>
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" xl="4" lg="4">
                                                <b-form-group
                                                        label="Level"
                                                        label-for="input-level"
                                                        :label-cols="4"
                                                        :horizontal="true">
                                                    <b-form-select id="input-level" v-model="data.level">
                                                        <option :value="1">1</option>
                                                        <option :value="2">2</option>
                                                        <option :value="3">3</option>
                                                        <option :value="4">4</option>
                                                        <option :value="5">5</option>
                                                        <option :value="6">Hoạt Động</option>
                                                    </b-form-select>
                                                </b-form-group>
                                        </b-col>
                                    </b-row>


                                  <hr>
                                  <h6>Thay đổi mật khẩu</h6>
                                  <b-form-group

                                    label="Mật khẩu"
                                    label-for="input-password"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <b-form-input id="input-password" type="text" placeholder="Nhập mật khẩu mới"  v-model="password1"></b-form-input>
                                  </b-form-group>

                                  <b-form-group
                                    label="Xác nhận mật khẩu"
                                    label-for="input-confirm-password"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <b-form-input id="input-confirm-password" type="text" placeholder="Xác nhận mật khẩu mới"  v-model="password2"></b-form-input>
                                  </b-form-group>
                                </b-col>

                                <b-col cols="6" xl="6" lg="12">
                                  <h6 class="mb-3">Thông tin sử dụng</h6>

                                  <b-form-group
                                    label="Cài đặt đã lưu"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <ul class="mt-2 mb-0 pl-3" v-if="data.settings">
                                      <li v-for="(value, key) in data.settings" :key="key">
                                        {{ key }}: <b v-if="value">{{ value }}</b>
                                      </li>
                                    </ul>
                                  </b-form-group>

                                  <b-form-group
                                    label="Tần suất login tuần hiện tại"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <div class="mt-2">
                                      <template v-if="data.userStatics && data.userStatics.last7DaysCount">
                                        <strong>{{data.userStatics.last7DaysCount}}</strong><i class="ml-1">(lần)</i>
                                      </template>

                                    </div>

                                  </b-form-group>

                                  <b-form-group
                                    label="Tần suất login các tuần trước"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <div class="mt-2">

                                      <date-range-picker
                                        v-model="dateRange"
                                        :date-format="dateFormat"

                                        :locale-data="localeData"
                                        :opens="opens"
                                        @update="pickerUpdate"
                                      ></date-range-picker>

                                      <div class="mt-4" v-if="data.userStatics && data.userStatics.customRangeCount >= 0">
                                        <strong>Kết quả</strong>
                                        <ul class="pl-4">
<!--                                          <li>Thời gian: {{ selectedDate }}</li>-->
                                          <li>Tần suất login: <b>{{ data.userStatics.customRangeCount ? data.userStatics.customRangeCount : '' }}</b></li>
                                        </ul>
                                      </div>
                                    </div>
                                  </b-form-group>

                                  <b-form-group
                                    label="Login lần cuối"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <div class="mt-2">
                                      <strong>{{ data.last_login|formatDate("DD-MM-YYYY, H:m") }}</strong></div>
                                  </b-form-group>

                                  <b-form-group
                                    label="Đã không login"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <div class="mt-2">
                                      <strong>{{ data.last_login|formatLastLoginDiff }}</strong></div>
                                  </b-form-group>

                                  <b-form-group
                                    label="Lần lọc cuối"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <div class="mt-2">
                                      <template v-if="data.filterStatics && data.filterStatics.lastUsed">
                                        <strong>{{ data.filterStatics.lastUsed }}</strong>
                                      </template>
                                    </div>
                                  </b-form-group>

                                  <b-form-group
                                    label="Tổng số lần lọc"
                                    :label-cols="2"
                                    :horizontal="true">
                                    <div class="mt-2">
                                      <template v-if="data.filterStatics && data.filterStatics.totalUses >=0">
                                        <strong>{{ data.filterStatics.totalUses }}</strong><i class="ml-1">(lần)</i>
                                      </template>
                                    </div>
                                  </b-form-group>

                                </b-col>
                            </b-row>
                            <b-row>

                            </b-row>
                            <div slot="footer" class="">
                                <b-button type="submit" variant="primary">Lưu lại</b-button>
                                <b-button type="button" class="ml-2" :to="{path:'/users'}">Quay lại</b-button>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
              <b-row>
                <b-col sm="12">
                  <b-card>
                    <div slot="header">
                      <h5>Các bộ lọc đã lưu</h5>
                    </div>
                    <b-row>
                      <b-col>
                        <FilterCard
                          title="Bộ lọc sẵn : CIM"
                          :total-uses="(CIM && CIM.totalUses) ? CIM.totalUses : 0 "
                          :last-used="((CIM && CIM.lastUsed) ? CIM.lastUsed : null)"
                          :conditions="[]"
                        />
                      </b-col>
                      <b-col>
                        <FilterCard
                          title="Bộ lọc sẵn : CTM"
                          :total-uses="(CTM && CTM.totalUses) ? CTM.totalUses : 0 "
                          :last-used="((CTM && CTM.lastUsed) ? CTM.lastUsed : null)"
                          :conditions="[]"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col v-for="(filter, index) in filters" :key="index" md="6">
                        <FilterCard
                          :title="filter.name"
                          :total-uses="filter.totalUses || 0"
                          :last-saved="filter.updatedAt"
                          :last-used="filter.lastUsed"
                          :conditions="filter.condition"
                        />
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-form>
        </b-row>
        <b-row v-else>
          <p class="alert alert-warning">Bạn không có quyền truy cập mục này.</p>
        </b-row>
    </div>
</template>

<script>
import moment from "moment";

import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import FilterCard from "@/components/FilterCard";

export default {
  name: 'UserAdd',
  components: {
    DateRangePicker,
    FilterCard,
  },
  data() {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    return {
      isSuperAdminAccount: false,
      data: {
        name: null,
        email: null,
        group: null,
        phone: null,
        address: null,
        birthday: null,
        image: null,
        status: 1,
      },
      password1: null,
      password2: null,
      loading: false,
      group: [],

      // date range picker
      localeData: {
        direction: 'ltr',
        format: 'dd/mm/yyyy',
        separator: ' - ',
        applyLabel: 'Áp dụng',
        cancelLabel: 'Hủy',
        weekLabel: 'Tuần',
        customRangeLabel: 'Khoảng',
        daysOfWeek: ['CN', 'Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy'],
        monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5',
          'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
        firstDay: 0
      },
      opens: 'center',
      togglePicker: false,
      dateRange: {
        startDate: today,
        endDate: today,
      },
      selectedDate: '',

      // dữ liệu mẫu
      filters: [],
      CIM: null,
      CTM: null
    };

  },
  created() {
    this.fetchData();
  },
  computed: {

    canEdit() {
      return true;
    }

  },
  watch: {},
  methods: {
    async save() {
      const {id} = this.$route.params || {}

      const user = this.$cookies.get('user');
      this.$gtag.event('click_update_member', {
        event_category: 'click_events',
        event_label: 'Update member button',
        user_type: 'admin',
        user_id: user?._id,
      });

      if (!id || id === "") {
        this.$toasted.error("Không tải được dữ liệu", {
          duration: 3000
        });
        return false;
      }
      //kiem tra bat buoc
      if (!this.data.name) {
        this.$toasted.show("Vui lòng nhập tên", {
          type: "error",
          duration: 5000
        });
        return false;
      }
      if (!this.data.email) {
        this.$toasted.show("Vui lòng nhập địa chỉ email", {
          type: "error",
          duration: 5000
        });
        return false;
      }

      if (this.password1
        && this.password1 !== '') {
        if (this.password1.length <= 5) {
          this.$toasted.show("Mật khẩu cần tối thiểu 6 ký tự", {
            type: "error",
            duration: 5000
          });
          return false;
        } else if (this.password1 !== this.password2) {
          this.$toasted.show("Nhập lại mật khẩu không chính xác", {
            type: "error",
            duration: 5000
          });
          return false;
        }
      }
      //Lưu lại
      this.loading = true;
      try {

        let params = {
          ...this.data
        }

        if (this.password1) {
          params.password = this.password1
        }

        // Gửi yêu cầu API bằng Axios và đưa token vào header
        const {data} = await this.$axios.put(this.$configs.api + '/api/v4/cp/users/' + id, params);

        this.$gtag.event('update_member', {
          event_category: 'member_events',
          event_label: 'Update member',
          user_type: 'admin',
          user_id: user?._id,
          req: JSON.stringify(params) || null,
          res: JSON.stringify(data) || null,
        });

        if (data && data._id) {
          this.$toasted.success("Đã lưu thành công", {
            duration: 5000
          });

          this.password1 = null
          this.password2 = null
          this.$router.push({path: `/users/${data._id}`})
        }

      } catch (err) {
        // Kiểm tra xem có lỗi phản hồi từ máy chủ không
        if (err.response && (err.response.status === 500 || err.response.status !== 200)) {
          this.$toasted.error(err.response.data.message || "Đã xảy ra lỗi không mong muốn từ máy chủ", {
            duration: 5000
          });
        } else {
          // Xử lý các lỗi khác
          this.$toasted.error(err.message, {
            duration: 5000
          });
        }
      } finally {
        this.loading = false
      }
    },
    async fetchData() {
      const {id} = this.$route.params || {}
      if (!id || id === "") {
        this.$toasted.error("Không tải được dữ liệu", {
          duration: 3000
        });
        this.$router.push({path: "/users"});
        return false;
      }
      this.loading = true;

      try {
        const {data} = await this.$axios.get(`${this.$configs.api}/api/v4/cp/users/${id}`)

        if (data && data._id) {
          this.data = { ...this.data, ...data}
          if (data?.filterStatics?.filters) {
            this.filters = data.filterStatics.filters
            this.CIM = data.filterStatics.CIM
            this.CTM = data.filterStatics.CTM
          }
        }


      } catch (err) {
        if (err && err.response) {
          if (err.response.data && err.response.data.message) {
            this.$toasted.show(err.response.data.message, {
              type: "error",
              duration: 3000
            });
            return false;
          }
        } else {
          this.$toasted.show("Đã có lỗi hệ thống xảy ra", {
            type: "error",
            duration: 3000
          });
        }
      } finally {
        this.loading = false
      }

    },

    dateFormat(classes, date) {
      if (!classes.disabled) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Đặt giờ phút giây của ngày hôm nay về 0 để so sánh chính xác

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1); // Thêm một ngày để có ngày mai

        const threeHundredDaysAgo = new Date();
        threeHundredDaysAgo.setDate(threeHundredDaysAgo.getDate() - 300);
        threeHundredDaysAgo.setHours(0, 0, 0, 0); // Đặt giờ phút giây của ngày cách đây 300 ngày về 0

        classes.disabled = date.getTime() < threeHundredDaysAgo.getTime() || date.getTime() > tomorrow.getTime();
      }
      return classes;
    },
    async pickerUpdate() {
      let {startDate, endDate} = this.dateRange
      if (startDate && endDate) {
        startDate = moment(startDate,'DD-MM-YYYY').format('YYYY-MM-DD')
        endDate = moment(endDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
      let params = {
        startDate: startDate ?? null,
        endDate: endDate ?? null,
        userId: this.data._id ?? null,
      }
      // Convert params to query string
      let qs = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');

      try {
        const {data} = await this.$axios.get(`${this.$configs.api}/api/user-activities/statics?${qs}`);
        if (data) {
          this.data.userStatics = data
        }
      } catch (e) {

      } finally {

      }

    },
  },
  filters: {
    formatLastLoginDiff(lastLogin) {
      if ('Invalid date' === lastLogin || !lastLogin) return;
      const now = moment();
      const lastLoginDate = moment(lastLogin);
      const diffDays = now.diff(lastLoginDate, 'days');
      const diffHours = now.diff(lastLoginDate, 'hours');

      if (diffDays >= 1) {
        return `${diffDays} ngày trước`;
      } else {
        return `${diffHours} giờ trước`;
      }
    },
  }
}
</script>

